(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["full-bleed-image"] && !Shopify.designMode) return;
  try {
    
  const initFullBleedHeroVideos = () => {
    for (const root of document.querySelectorAll('[data-full-bleed-hero]')) {
      for (const video of root.querySelectorAll('.full-bleed-hero__media video')) {
        if (video.dataset.fullBleedBound === 'true') continue;
        video.dataset.fullBleedBound = 'true';

        const playLabel = root.dataset.playLabel || 'Play video';
        const pauseLabel = root.dataset.pauseLabel || 'Pause video';

        const syncLabel = () => {
          video.setAttribute('aria-label', video.paused ? playLabel : pauseLabel);
        };

        video.setAttribute('tabindex', '0');
        video.setAttribute('role', 'button');
        syncLabel();

        video.addEventListener('click', (event) => {
          event.preventDefault();
          if (video.paused) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
          syncLabel();
        });

        video.addEventListener('keydown', (event) => {
          if (event.key !== 'Enter' && event.key !== ' ') return;
          event.preventDefault();
          if (video.paused) {
            video.play().catch(() => {});
          } else {
            video.pause();
          }
          syncLabel();
        });

        video.addEventListener('play', syncLabel);
        video.addEventListener('pause', syncLabel);
      }
    }
  };

  initFullBleedHeroVideos();
  document.addEventListener('shopify:section:load', initFullBleedHeroVideos);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
